import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocaleStrings from "@language";
import Recharge from "./components/recharge";
import { fetchVehicleList } from "@numberplateaction";
import { fetchBagdeList } from "@badgesaction";
import {
  fetchBalance,
  fetchPackage,
  openRechargeModal,
  fetchPurchaseTransaction,
  emptyTransaction,
  downloadInvoice,
  fetchConversionRate,
} from "@transactionaction";
import { fetchMyProfile } from "@personalinfoaction";
import ItemList from "../transactions/components/item-list";
import Loader from "@loader";
import _ from "lodash";
import toast from "react-hot-toast";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Dashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  var {
    session,
    eventData,
    packageList,
    transactionList,
    myProfile,
    conversionRate,
    localeLanguage,
  } = props;

  const tabsArr = [
    {
      key: "bought",
      name: LocaleStrings.bought,
      href: "#",
      current: true,
    },
    {
      key: "spent",
      name: LocaleStrings.spent,
      href: "#",
      current: false,
    },
  ];
  const [currentTab, setCurrentTab] = useState("bought");
  const [tabs, setTabs] = useState(tabsArr);
  const [tokenCost, setTokenCost] = useState(null);

  useEffect(() => {
    //var userLang = LocaleStrings.getLanguage();
    if (localeLanguage) {
      let tabsArr = [
        {
          key: "bought",
          name: LocaleStrings.bought,
          href: "#",
          current: true,
        },
        {
          key: "spent",
          name: LocaleStrings.spent,
          href: "#",
          current: false,
        },
      ];
      setTabs(tabsArr);
    }
  }, [localeLanguage]);

  useEffect(() => {
    if (eventData) {
      props.fetchPackage(props.session, eventData.useridfk);
      props.fetchConversionRate(props.session, eventData.useridfk);
      let pobj = {};
      pobj.startdate = "";
      pobj.enddate = "";
      pobj.companyid = eventData.useridfk;
      props.fetchPurchaseTransaction(props.session, pobj, "purchase");

      props.fetchVehicleList(props.session, eventData.useridfk, 0, (res) => {});
      props.fetchBagdeList(props.session, eventData.useridfk, 0, (res) => {});
    }

    props.fetchMyProfile(session);
  }, [eventData]);

  useEffect(() => {
    const urlpath = location.search;
    const transactionid = new URLSearchParams(urlpath).get("transactionid");

    if (transactionid) {
      props.fetchMyProfile(session, (res) => {});
      // props.downloadInvoice(
      //   session,
      //   transactionid,
      //   "generate_invoice",
      //   (response) => {},
      //   "transactioncode"
      // );
      props.fetchBalance(session, eventData.useridfk);
      let pobj = {};
      pobj.startdate = "";
      pobj.enddate = "";
      pobj.companyid = eventData.useridfk;
      props.fetchPurchaseTransaction(props.session, pobj, "purchase");
    }
  }, []);

  const redirectPage = (section) => {
    if (section == "numberplate") {
      navigate("/numberplate");
    } else if (section == "badge") {
      navigate("/badges");
    } else if (section == "transaction") {
      navigate("/transactions");
    }
  };

  const openRecharge = (item) => {
    //console.log("item", item);
    //console.log("conversionRate", conversionRate);
    let objItem = {};
    let tokenamount = 1;
    if (
      conversionRate &&
      conversionRate.length > 0 &&
      conversionRate[0]["tokenamount"]
    ) {
      tokenamount = conversionRate[0]["tokenamount"];
    }
    let freetoken = item.freetoken;
    let paidtoken = item.paidtoken;
    objItem.freetoken = freetoken * tokenamount;
    objItem.paidtoken = paidtoken * tokenamount;
    objItem.freetokenorg = freetoken;
    objItem.paidtokenorg = paidtoken;
    objItem.tokencost = item.tokencost;
    objItem.tokenvalidity = item.tokenvalidity;
    objItem.tokenname = item.tokenname;
    objItem.tokenid = item.tokenid;
    //console.log("objItem", objItem);
    // debugger;
    props.openRechargeModal({ showModal: true, obj: objItem });
  };

  const renderItems = () => {
    // console.log("transactionList", transactionList);
    return transactionList?.data?.map((item, index) => {
      return (
        <ItemList
          key={`key_${index}`}
          listitem={item}
          currentTab={currentTab}
        />
      );
    });
  };

  const handleTabs = (tab) => {
    props.emptyTransaction();
    let type = tab.key == "spent" ? "redeem" : "purchase";
    let pobj = {};
    pobj.startdate = "";
    pobj.enddate = "";
    pobj.companyid = eventData.useridfk;
    props.fetchPurchaseTransaction(props.session, pobj, type);
    tabs.map((obj) => {
      if (obj.key === tab.key) {
        obj.current = true;
      } else {
        obj.current = false;
      }
    });

    setCurrentTab(tab.key);
    setTabs([...tabs]);
  };

  /*const findClosest = (x) => {
    if (packageList?.data?.length > 0) {
      var indexArr = packageList.data.map(function (k) {
        return Math.abs(k.tokencost - x);
      });
      console.log("indexArr", indexArr);
      var min = Math.min.apply(Math, indexArr);
      console.log("min", min);
      return packageList.data[indexArr.indexOf(min)];
    } else {
      return 0;
    }
  };*/

  const findClosest = (x) => {
    if (packageList?.data?.length > 0) {
      // let result = _.minBy(packageList.data, "tokencost");

      // if (x >= result.tokencost) {
      return packageList.data.reduce((best, current) => {
        return current.tokencost <= x &&
          (!best || current.tokencost > best.tokencost)
          ? current
          : best;
      }, undefined);
      // } else {
      //   return { freetoken: 0, tokenvalidity: result.tokenvalidity };
      // }
    }
  };

  const freeAmount = (e) => {
    let tokencost = e.target.value;
    setTokenCost(tokencost);
  };
  const makeFreeAmountPayment = (e) => {
    if (tokenCost && tokenCost.length >= 1) {
      if (Number(tokenCost)) {
        let result = _.minBy(packageList.data, "tokencost");
        let tokenObj = {};
        if (tokenCost >= result.tokencost) {
          tokenObj = findClosest(tokenCost);
        } else {
          tokenObj = { freetoken: 0, tokenvalidity: result.tokenvalidity };
        }
        // console.log("tokenObj", tokenObj);
        if (!_.isEmpty(tokenObj)) {
          let tokenamount = 1;
          if (
            conversionRate &&
            conversionRate.length > 0 &&
            conversionRate[0]["tokenamount"]
          ) {
            tokenamount = conversionRate[0]["tokenamount"];
          }
          let item = {};
          item.tokenname = LocaleStrings.credit_amount;
          item.paidtoken = Number(tokenCost);
          item.paidtokenorg = tokenCost / tokenamount;
          item.freetoken = Number(tokenObj.freetoken) * tokenamount;
          item.freetokenorg = Number(tokenObj.freetoken);
          item.tokencost = tokenCost;
          item.tokenvalidity = tokenObj.tokenvalidity;
          item.description = `Purchase €${tokenCost}`;

          setTimeout(() => {
            props.openRechargeModal({ showModal: true, obj: item });
          }, 1000);
        }
      } else {
        setTokenCost(null);
        toast.error(LocaleStrings.invalid_amount);
      }
    }
  };

  const numberValidate = (evt) => {
    var theEvent = evt || window.event;

    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };

  let tokenamount = 1;
  if (
    conversionRate &&
    conversionRate.length > 0 &&
    conversionRate[0]["tokenamount"]
  ) {
    tokenamount = conversionRate[0]["tokenamount"];
  }
  console.log("myProfile", myProfile);
  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 lg:gap-8">
          <div className="bg-white rounded w-full p-6 text-base shadow-2xl">
            <div className="border-b pb-2">{LocaleStrings.charge_credit}</div>
            <div className="w-full text-center pt-6  ">
              {packageList && packageList.data ? (
                packageList.data.length > 0 ? (
                  <>
                    <div className="space-y-4 h-72 overflow-y-scroll">
                      {packageList?.data?.map((item, index) => {
                        return (
                          <div
                            className="flex items-center justify-center relative cursor-pointer"
                            onClick={() => openRecharge(item)}
                          >
                            <div className="w-3/4 bg-chargecredit rounded border border-blue py-4 px-2 text-bluetext">
                              &euro;
                              {item.tokencost.toFixed(2).replace(".", ",")}
                            </div>
                            {item.freetoken > 0 ? (
                              <div className="absolute right-0 top-1/4 w-1/4 md:w-1/3 manage_bg rounded text-white text-sm py-1">
                                + &euro;
                                {(item.freetoken * tokenamount)
                                  .toFixed(2)
                                  .replace(".", ",")}{" "}
                                {LocaleStrings.free}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <div class="sticky bottom-0">
                      <div className="flex items-center justify-center relative pt-6">
                        <input
                          //onKeyPress={(e) => numberValidate(e)}
                          onChange={(e) => freeAmount(e)}
                          type="text"
                          placeholder={LocaleStrings.enter_amount}
                          className="w-3/4 rounded border border-gray-200 py-4 px-2  focus:outline-none"
                        />
                        <div className="absolute right-0">
                          <button
                            type="button"
                            className="text-bluetext border border-gray-200  font-medium rounded text-sm py-4 px-2 text-center inline-flex items-center"
                            onClick={() => makeFreeAmountPayment()}
                          >
                            <svg
                              class="w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )
              ) : (
                <Loader />
              )}
            </div>
          </div>
          <div className="bg-white rounded w-full p-6 text-base shadow-2xl">
            <div className="border-b pb-2">{LocaleStrings.number_plates}</div>
            <div className="w-full text-center pt-6 space-y-4 h-80 overflow-y-scroll">
              {props.vehicleList?.data?.slice(0, 4).map((item, index) => {
                return (
                  <div className="flex items-center gap-3">
                    <div className="w-1/2 px-3 py-2 bg-white rounded border border-numberplate p-2 text-numberplate text-sm">
                      {item.numberplate}
                    </div>
                    <div className="w-1/2 pl-4 text-sm text-left">
                      {item.reference}
                    </div>
                  </div>
                );
              })}
              {props.vehicleList?.data?.length > 4 ? (
                <div className="flex items-center justify-start">
                  {LocaleStrings.more} ...
                </div>
              ) : (
                ""
              )}
            </div>
            <div class="sticky bottom-0 pt-7">
              <div className="flex items-center justify-center">
                <div
                  className="button-managebutton  rounded py-2 px-5 cursor-pointer"
                  onClick={() => redirectPage("numberplate")}
                >
                  {LocaleStrings.manage_numberplate}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded w-full p-6 text-base shadow-2xl">
            <div className="border-b pb-2">{LocaleStrings.badges}</div>
            <div className="w-full text-center pt-6 space-y-4 h-80 overflow-y-scroll">
              {props.badgeList?.data?.slice(0, 4).map((item, index) => {
                return (
                  <div className="flex items-center gap-3">
                    <div className="w-1/2 px-3 py-2 bg-white rounded border border-badge p-2 text-badge text-sm">
                      {item.numberplate}
                    </div>
                    <div className="w-1/2 pl-4 text-sm text-left">
                      {item.reference}
                    </div>
                  </div>
                );
              })}
              {props.badgeList?.data?.length > 4 ? (
                <div className="flex items-center justify-start">
                  {LocaleStrings.more} ...
                </div>
              ) : (
                ""
              )}
            </div>
            <div class="sticky bottom-0 pt-7">
              <div className="flex items-center justify-center">
                <div
                  className="button-managebutton rounded py-2 px-5 cursor-pointer"
                  onClick={() => redirectPage("badge")}
                >
                  {LocaleStrings.manage_badge}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8">
          <div className="bg-white rounded w-full p-6 shadow-2xl">
            <div className="pb-2 mb-4">{LocaleStrings.my_transaction}</div>

            <div>
              <div className="">
                <nav
                  className="flex justify-center space-x-4"
                  aria-label="Tabs"
                >
                  {tabs.map((item) => (
                    <a
                      key={item.name}
                      onClick={() => handleTabs(item)}
                      className={classNames(
                        item.current
                          ? "manage_bg text-white"
                          : "bg-chargecredit text-bluetext cursor-pointer",
                        "px-6 md:px-12 py-2 font-medium text-sm rounded-md"
                      )}
                      aria-current={item.current ? "page" : undefined}
                    >
                      {item.name}
                    </a>
                  ))}
                </nav>
                <div className="overflow-x-auto">
                  <div className="align-middle inline-block min-w-full">
                    {transactionList?.data ? (
                      <div className="overflow-hidden ">
                        <table className="min-w-full divide-y divide-gray-200 mt-5">
                          <thead className="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                {LocaleStrings.date_header}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                {LocaleStrings.amount_header}
                              </th>
                              {currentTab == "bought" ? (
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  {LocaleStrings.paid_header}
                                </th>
                              ) : (
                                ""
                              )}
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                {currentTab == "bought"
                                  ? LocaleStrings.free_header
                                  : LocaleStrings.tr_service_header}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                {currentTab == "bought"
                                  ? LocaleStrings.payment_header
                                  : LocaleStrings.tr_numberplate_header}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                {currentTab == "bought"
                                  ? LocaleStrings.validity_header
                                  : LocaleStrings.tr_reference_header}
                              </th>
                              {currentTab == "bought" ? (
                                <th
                                  scope="col"
                                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                  {myProfile && myProfile.iscompanyhr == 1
                                    ? LocaleStrings.invoice_header
                                    : LocaleStrings.ticket_header}
                                </th>
                              ) : (
                                ""
                              )}
                            </tr>
                          </thead>
                          <tbody>{renderItems()}</tbody>
                        </table>
                        {transactionList?.data?.length > 3 ? (
                          <div className="flex items-center justify-center pt-12">
                            <div
                              className="button-managebutton rounded py-2 px-5 cursor-pointer"
                              onClick={() => redirectPage("transaction")}
                            >
                              {LocaleStrings.view_all}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {props.openRecharge && props.openRecharge.showModal ? <Recharge /> : ""}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    vehicleList: state.vehicleList,
    badgeList: state.badgeList,
    eventData: state.eventData,
    packageList: state.packageList,
    openRecharge: state.openRecharge,
    transactionList: state.transactionList,
    myProfile: state.myProfile.data,
    conversionRate: state.conversionRate.data,
    localeLanguage: state.localeLanguage,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchVehicleList,
      fetchBagdeList,
      fetchPackage,
      openRechargeModal,
      fetchPurchaseTransaction,
      fetchBalance,
      emptyTransaction,
      fetchMyProfile,
      downloadInvoice,
      fetchConversionRate,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
